import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecurityContextService } from '@services/security_context.service';
import { SyncWorkerSettingService } from '@services/sync-worker-setting.service';

export const redirectSyncRobotAccountsHomeGuard: CanActivateFn = async () => {
  const securityContextService = inject(SecurityContextService);
  const syncWorkerSettingService = inject(SyncWorkerSettingService);
  const router = inject(Router);

  if (!securityContextService.isLoggedIn()) {
    return router.parseUrl('/login');
  }

  try {
    const isAccountOnSyncWorker =
      await syncWorkerSettingService.isAccountOnSyncWorker();
    return isAccountOnSyncWorker ? true : router.parseUrl('/home');
  } catch (error) {
    console.error(error);
    return true;
  }
};
